import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { HTMLNotification } from "@/components/Notification/interface";

@Component
export default class IBNotificationReadDOM extends Vue {

	@Prop({ type: IntersectionObserver, default: null })
	readonly scrollIntersectionObserver!: IntersectionObserver | null

	readonly list!: any[]

	addElementsToScrollIntersectionObserver(): unknown {
		if (!this.scrollIntersectionObserver) return;

		const els: HTMLNotification[] = [].slice.call(
			this.$el.querySelectorAll('.js-notification-item')
		);

		if (!els.length)
			return setTimeout(() => this.addElementsToScrollIntersectionObserver());

		els.forEach((el, index) => {
			el.NOTIFICATION_ID = this.list[index].id;

			this.scrollIntersectionObserver!.observe(el);
		});
	}

	@Watch('scrollIntersectionObserver')
	scrollIntersectionObserverChange() {
		this.addElementsToScrollIntersectionObserver();
	}

}